export enum SessionEventType {
	SESSION_CREATED = 'SessionCreated',
	SESSION_REFRESHED = 'SessionRefreshed',
	SESSION_DESTROYED = 'SessionDestroyed',
	SESSION_SERVICE_READY = 'SessionServiceReady',
	SESSION_REPOSITORY_READY = 'SessionRepositoryReady',
}
